import {
  doc, getDoc, setDoc, updateDoc, serverTimestamp,
} from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { updateProfile, updateEmail, updatePassword, EmailAuthProvider, reauthenticateWithCredential } from 'firebase/auth';
import { db, storage, auth } from './firebase';

const COLLECTION = 'accounts';

// ======== DADOS PADRÃO ========
const DEFAULT_ACCOUNT = {
  // Perfil
  nomeEmpresa: 'SimulaBank',
  nomeUsuario: '',
  telefone: '',
  // White Label
  logoUrl: '',
  faviconUrl: '',
  corPrimaria: '#0B1D35',
  corAcento: '#00D68F',
  corTexto: '#1E293B',
  corFundo: '#F7F8FA',
  corSidebar: '#0B1D35',
  corSidebarTexto: '#94A3B8',
  corSidebarAtivo: '#00D68F',
  fontFamily: "'DM Sans', sans-serif",
  // Plano
  plano: 'Simulador',
};

// ======== BUSCAR CONTA ========
export const getAccount = async (userId) => {
  const snap = await getDoc(doc(db, COLLECTION, userId));
  if (snap.exists()) return { id: snap.id, ...DEFAULT_ACCOUNT, ...snap.data() };
  return { id: userId, ...DEFAULT_ACCOUNT };
};

// ======== CRIAR / ATUALIZAR CONTA ========
export const saveAccount = async (userId, data) => {
  const ref = doc(db, COLLECTION, userId);
  const snap = await getDoc(ref);
  if (snap.exists()) {
    await updateDoc(ref, { ...data, atualizadoEm: serverTimestamp() });
  } else {
    await setDoc(ref, { ...DEFAULT_ACCOUNT, ...data, criadoEm: serverTimestamp(), atualizadoEm: serverTimestamp() });
  }
};

// ======== UPLOAD LOGO / FAVICON ========
export const uploadAccountImage = async (userId, file, type = 'logo') => {
  const ext = file.name.split('.').pop();
  const path = `accounts/${userId}/${type}.${ext}`;
  const storageRef = ref(storage, path);
  await uploadBytes(storageRef, file, { contentType: file.type });
  return getDownloadURL(storageRef);
};

// ======== ATUALIZAR AUTH PROFILE ========
export const updateAuthProfile = async (displayName) => {
  if (auth.currentUser) {
    await updateProfile(auth.currentUser, { displayName });
  }
};

// ======== ATUALIZAR EMAIL ========
export const updateAuthEmail = async (newEmail, currentPassword) => {
  const user = auth.currentUser;
  if (!user) throw new Error('Usuário não autenticado');
  const credential = EmailAuthProvider.credential(user.email, currentPassword);
  await reauthenticateWithCredential(user, credential);
  await updateEmail(user, newEmail);
};

// ======== ATUALIZAR SENHA ========
export const updateAuthPassword = async (currentPassword, newPassword) => {
  const user = auth.currentUser;
  if (!user) throw new Error('Usuário não autenticado');
  const credential = EmailAuthProvider.credential(user.email, currentPassword);
  await reauthenticateWithCredential(user, credential);
  await updatePassword(user, newPassword);
};